export const isUndefinedOrNull = <T>(val: T) => {
  return val === null || val === undefined
}
